import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/web.dom-collections.for-each.js";
// @ts-nocheck

/* eslint-disable */
import common from '@/utils/common';
export default {
  namespaced: true,
  state: {
    showType: '',
    activeKey: '',
    formList: [],
    activeForm: null,
    rules: {},
    grid: {},
    formAttr: {},
    ruleForm: {}
  },
  mutations: {
    // 同步更新事件
    updateShowType: function updateShowType(state, value) {
      state.showType = value;
    },
    updateActiveKey: function updateActiveKey(state, value) {
      state.activeKey = value;
    },
    updateFormAttr: function updateFormAttr(state, value) {
      state.formAttr = value;
    },
    updateFormList: function updateFormList(state, value) {
      state.formList = value;
      value.forEach(function (element) {
        if (element.type !== 'grid') {
          state.rules[element.key] = [{
            required: element.options.required,
            message: '必填项不能为空',
            trigger: 'blur'
          }];
        } else {
          element.cols.forEach(function (element2) {
            element2.list.forEach(function (element3) {
              state.rules[element3.key] = [{
                required: element3.options.required,
                message: '必填项不能为空',
                trigger: 'blur'
              }];
            });
          });
        }

        state.ruleForm[element.key] = element.value;
      });
      console.log("state.rules", state.rules);
    },
    updateActiveForm: function updateActiveForm(state, value) {
      state.activeForm = value;
    },
    updateRules: function updateRules(state, value) {
      state.rules = value;
    },
    updateGrid: function updateGrid(state, value) {
      state.grid[value.key] = value.value;
    }
  },
  actions: {
    // 异步提交事件
    setFormAttr: function setFormAttr(_ref, value) {
      var commit = _ref.commit;
      commit('updateFormAttr', value);
    },
    setFormList: function setFormList(_ref2, value) {
      var commit = _ref2.commit;
      window.localStorage.formList = JSON.stringify(value);
      commit('updateFormList', value);
    },
    addFormList: function addFormList(_ref3, form) {
      var commit = _ref3.commit,
          state = _ref3.state;
      console.log("addFormList"); // let newFormList = JSON.parse(window.localStorage.formList).push(form);

      var newFormList = common.deepClone(state.formList);
      newFormList.push(form);
      window.localStorage.formList = JSON.stringify(newFormList);
      commit('updateFormList', newFormList);
    },
    removeFormList: function removeFormList(_ref4, key) {
      var commit = _ref4.commit;
      var newFormList = JSON.parse(window.localStorage.formList);
      var delIndex = -1;

      for (var i = 0; i < newFormList.length; i++) {
        var element = newFormList[i];

        if (element.key === key) {
          delIndex = i;
        }
      }

      if (delIndex !== -1) {
        newFormList.splice(delIndex, 1);
      } else {
        console.warn("未找到此表单key", key);
      }

      window.localStorage.formList = JSON.stringify(newFormList);
      commit('updateFormList', newFormList);
    }
  },
  getters: {
    getFormRules: function getFormRules(state) {
      var rules = {};
      state.formList.forEach(function (element) {
        rules[element.key] = [{
          required: element.options.required,
          message: '必填项不能为空',
          trigger: 'blur'
        }];
      });
      console.log("rules", rules);
      return rules;
    }
  }
};